module.exports = __webpack_public_path__ + "static/far-cry_smartphone-41464d0c3020156ddaa6f933f05db940.png";